import { isArray } from "../is.js";
function setClasses(element, classNames, method, forceToggle) {
  if (!element || !classNames) {
    return;
  }
  const normalizedClassNames = isArray(classNames) ? classNames : classNames.split(" ");
  if (method !== "toggle") {
    element.classList[method](...normalizedClassNames);
  } else {
    normalizedClassNames.forEach((className) => element.classList[method](className, forceToggle));
  }
}
function add(element, classNames) {
  setClasses(element, classNames, "add");
}
function remove(element, classNames) {
  setClasses(element, classNames, "remove");
}
function toggle(element, classNames, force) {
  setClasses(element, classNames, "toggle", force);
}
export {
  add,
  remove,
  toggle
};
